
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { useDispatch, useSelector } from 'react-redux';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';

import { getActions } from '../sagas';
import { IfComp, PanelTitle } from '../../core';
import { sagas as sagasMap, getToolsMode } from '../../map';

import MeasurePanel from './MeasurePanel';

const MeasurementPanel = () => {

    const classNames = mergeStyleSets({
        MeasurementPanel: {
            padding: 4
        },
        status: {}
    });

    const dispatch = useDispatch();
    const measurementActions = getActions(dispatch);
    const mapActions = sagasMap.getActions(dispatch);

    // ToDo: use constant 'MEASURE' from module `map`
    const measurementEnabled = useSelector(state => getToolsMode(state.map.map) === 'MEASURE');

    const handleChange = (e, checked) => {
        mapActions.setToolsMode(
            checked ? 'MEASURE' : 'DEFAULT'
        );
        if (!checked) {
            measurementActions.setMeasureValues(null);
            measurementActions.clearMeasureList();
        }
    }

    return (
        <Stack verticalFill className={classNames.MeasurementPanel} tokens={{childrenGap: 4}}>
            <Stack.Item align="stretch">
                <PanelTitle title="MĚŘENÍ" />
            </Stack.Item>
            <Stack.Item>
                <Toggle
                    onText="Zapnuto"
                    offText="Vypnuto"
                    checked={measurementEnabled}
                    inlineLabel
                    onChange={handleChange}
                />
            </Stack.Item>
            <Stack.Item>
                <IfComp cond={measurementEnabled}>
                    <div className={classNames.status}>Použijte příslušné nástroje pro měření ve 2D mapě nebo 3D okně.</div>
                </IfComp>
            </Stack.Item>
            <Stack.Item>
                <IfComp cond={measurementEnabled}>
                    <MeasurePanel />
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

export default MeasurementPanel;
